import docsUIStore from './docsUIStore.js';
import docsDataStore from './docsDataStore.js';

export default {
  modules: {
    ui: docsUIStore,
    data: docsDataStore
  }
};
